import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/common/auth-guard';
import { AuthService } from './services/common/services-auth';


const routes: Routes = [
  {
    path: 'demographics',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./demographics/demographics.module').then(m => m.DemographicsModule)
  },
  {
    path: 'business-account',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./business-account/business-account.module').then(m => m.BusinessAccountModule)
  },
  {
    path: 'gapmaps-db',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./gapmaps-db/gapmaps-db.module').then(m => m.GapmapsDBModule)
  },
  {
    path: 'user-notifications',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./user-notifications/user-notifications.module').then(m => m.UserNotificationsModule)
  },
  {
    path: 'reports',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'insights',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule)
  },
  {
    path: 'platform-usage',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./platform-usage/platform-usage.module').then(m => m.PlatformUsageModule)
  },
  {
    path: 'data_manager',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./data_manager/data_manager.module').then(m => m.DataManagerModule)
  },
  {
    path: 'dimasi_configurator',
    canActivate: [AuthGuardService],
    loadChildren:
      () => import('./dimasi-configurator/dimasi-configurator.module').then(m => m.DimasiConfiguratorModule)
  },
  {
    path: 'pin_generator',
    canActivate: [AuthGuardService],
    loadChildren:
      () => import('./pin-generator/pin-generator.module').then(m => m.PinGeneratorModule)
  },
  {
    path: 'language_manager',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./language-manager/language-manager.module').then(m => m.LanguageManagerModule)
  },
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    pathMatch: 'full',
    canActivate: [AuthGuardService]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {})
  ],
  exports: [RouterModule],
  providers: [
    AuthGuardService,
    AuthService
  ]
})
export class AppRoutingModule { }
